module.exports = __webpack_public_path__ + "media/images/regions_old/Diffa-5b5d905f087014ac1f661732759094d7.png";